/* 🤖 this file was generated by svg-to-ts */
export const DfIconCrossCircle16: {
  name: 'cross-circle-16';
  data: string;
} = {
  name: 'cross-circle-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm1.258-8 1.468-1.468a.89.89 0 0 0-1.258-1.258L8 6.742 6.487 5.229c-.322-.322-.865-.302-1.213.045-.347.348-.367.89-.045 1.213L6.742 8 5.274 9.468a.89.89 0 0 0 1.258 1.258L8 9.258l1.513 1.513c.322.322.865.302 1.213-.045.347-.348.367-.89.045-1.213z" fill-rule="evenodd"/></svg>`
};
